import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const Loading = ({ fullHeight }) => {
  return (
    <main>
      <Box className={fullHeight ? 'mainLoading' : 'loadingContainer'}>
        <CircularProgress size={26} color='primary' />
      </Box>
    </main>
  );
};

export default Loading;
